const usageTypes = [
  {
    id: 'MENU',
    name: 'メニュー'
  },
  {
    id: 'VOUCHER',
    name: '商品券'
  },
  {
    id: 'COMBO',
    name: '回数券'
  }
];
export default usageTypes;
